import PropTypes from 'prop-types';
import React from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { Mobile } from '../../Common/const';
import CustomPracticeExam from '../../CustomPracticeExam/CustomPracticeExamView';
import NotificationPopUp from '../../Headers/NotificationPopUp';
import Cycle from './cycle';

class PracticeExamHistoryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectOption: '',
      openDropdown: null,
      showCancelPopUp: false,
      practiceExamStatusChecked: false,
      openCustomExamModal: false,
    };

    this.renderDropDown = this.renderDropDown.bind(this);
  }

  componentDidMount() {
    this.setLocalStorage();
    this.props.getCustomPESettings();
    if (this.props.user?.id) {
      this.props.getWeeklyPracticeExams();
      this.setState({ practiceExamStatusChecked: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user?.id && !this.state.practiceExamStatusChecked) {
      this.props.getWeeklyPracticeExams();
      this.setState({ practiceExamStatusChecked: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.pfeSktId &&
      prevProps.pfeSktId !== this.props.pfeSktId &&
      !this.props.pfeSktIdWaiting
    ) {
      this.props.resetPracticeExamHistory();
      this.props.getWeeklyPracticeExams();
    }
  }

  getBlockingPopUp = () => {
    const { user } = this.props;
    if (!user || user.active === false) return this.openCancelPopUp;
    return null;
  };

  handleClickCustomExam = () => {
    const { user } = this.props;
    const openBlockingPopUp = this.getBlockingPopUp();
    if (openBlockingPopUp) {
      openBlockingPopUp(true);
      return;
    }

    if (this.props.references?.length === 0) {
      this.props.loadReferences(user.rate?.id);
    }
    this.setState({ openCustomExamModal: true });
  };

  openCancelPopUp = (value) => {
    this.setState({ showCancelPopUp: value });
  };

  handleDropdownClick = (dropdown) => {
    this.setState({
      openDropdown: this.state.openDropdown === dropdown ? null : dropdown,
    });
  };

  handleSelectOnClick = (e) => {
    this.setState({ openDropdown: null });
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ currentSelectOption: name });
    window.localStorage.setItem('optionSelectPracticeExamHistory', value);
  };

  initialitateSelectDefaultOption = (option) => {
    switch (option) {
      case 'firstScore':
        this.setState({ currentSelectOption: 'FIRST SCORE' });
        break;
      case 'lastScore':
        this.setState({ currentSelectOption: 'LAST SCORE' });
        break;
      case 'average':
        this.setState({ currentSelectOption: 'AVERAGE' });
        break;
      case 'points':
        this.setState({ currentSelectOption: 'POINTS' });
        break;
      default:
        this.setState({ currentSelectOption: '' });
    }
  };

  setLocalStorage = () => {
    let optionSelect = window
      ? window.localStorage.getItem('optionSelectPracticeExamHistory')
      : '';
    if (!optionSelect) {
      optionSelect = window.localStorage.setItem(
        'optionSelectPracticeExamHistory',
        'score',
      );
      optionSelect = 'score';
    }
    this.initialitateSelectDefaultOption(optionSelect);
  };

  renderDropDown = (dropdown) => (
    <Dropdown
      className="select-container ml-auto mr-auto"
      isOpen={this.state.openDropdown === dropdown}
      toggle={() => this.handleDropdownClick(dropdown)}
    >
      <DropdownToggle
        name="toggle"
        className="week-selector week-selector-width-exam widthExam pl-2 pr-2"
        style={{ maxWidth: '10rem !important' }}
      >
        <span>{this.state.currentSelectOption}</span>{' '}
        {this.state.openDropdown === dropdown ? (
          <i className="mr-2 icon-expand select-icon rotate down" />
        ) : (
          <i className="icon-expand select-icon rotate" />
        )}
      </DropdownToggle>
      <DropdownMenu
        onClick={this.handleSelectOnClick}
        className="mt-3 select-dropdown-menu"
      >
        <DropdownItem
          name="FIRST SCORE"
          value="firstScore"
          className={
            this.state.currentSelectOption === 'SCORE' ? 'selected-option' : ''
          }
        >
          First score
        </DropdownItem>
        <DropdownItem
          name="LAST SCORE"
          value="lastScore"
          className={
            this.state.currentSelectOption === 'LAST SCORE'
              ? 'selected-option'
              : ''
          }
        >
          Last score
        </DropdownItem>
        <DropdownItem
          name="AVERAGE"
          value="average"
          className={
            this.state.currentSelectOption === 'AVERAGE'
              ? 'selected-option'
              : ''
          }
        >
          Average
        </DropdownItem>
        <DropdownItem
          name="POINTS"
          value="points"
          className={
            this.state.currentSelectOption === 'POINTS' ? 'selected-option' : ''
          }
        >
          Points
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );

  render() {
    const exams = this.props.exams || [];
    const isCurrentTabSKT =
      !this.props.user?.rate?.isPfeOnly &&
      Number(this.props.pfeSktId) === Number(this.props.user?.rate?.id);
    const weeklyExamTitle = isCurrentTabSKT
      ? 'SKT Weekly Practice Exams'
      : 'PFE Weekly Practice Exams';
    const hasCustomExam =
      this.props.customPracticeExamStatus &&
      !this.props.customPracticeExamStatus.notGenerated;
    const isWeeklyEmpty = exams.length === 0;

    if (this.props.loadingPracticeExamHistory || this.props.pfeSktIdWaiting) {
      return (
        <div className="practice-exam-history-container">
          <div className="loading-history-gif-container pt-4 pl-3 pr-3">
            <CircularLoading className="loading-history-gif" />
          </div>
        </div>
      );
    }

    return (
      <div className="practice-exam-sections">
        {isCurrentTabSKT && (
          <div className="practice-exam-history-container custom-practice-exam-section mb-4">
            <div className="custom-practice-exam-header p-3">
              <div>
                <h4>Custom Practice Exam</h4>
                <p className="weekly-practice-exam-description mb-0">
                  Build an exam using the chapters you want to practice.
                </p>
              </div>
              <button
                className="btn rounded border-0 custom-exam-btn"
                onClick={this.handleClickCustomExam}
                disabled={
                  this.props.customPracticeExamStatus?.practiceExamRunning ||
                  this.props.customPracticeExamStatus?.availablePracticeExam ||
                  this.props.customPracticeExamStatus?.has24HoursPassed ===
                    false
                }
              >
                New Custom Practice Exam
              </button>
            </div>

            {hasCustomExam && (
              <div className="history-content px-3 pb-3">
                <Mobile>
                  <div className="mobile-practice-exam-selector mb-2">
                    {this.renderDropDown('custom')}
                  </div>
                </Mobile>
                <Cycle
                  section="custom"
                  selectOption={this.state.currentSelectOption}
                  exams={exams}
                  customPracticeExamHistory={
                    this.props.customPracticeExamHistory
                  }
                  customPracticeExamStatus={this.props.customPracticeExamStatus}
                  customPracticeExam={this.props.customPracticeExam}
                  customPracticeExamLoading={
                    this.props.customPracticeExamLoading
                  }
                  regenerateCustomPE={this.props.regenerateCustomPE}
                  user={this.props.user}
                  openCancelPopUp={this.openCancelPopUp}
                  startPracticeExam={this.props.startPracticeExam}
                  practiceExamRunning={this.props.practiceExamRunning}
                  practiceExamFlag={this.props.practiceExamFlag}
                  checkPracticeExamLoading={this.props.checkPracticeExamLoading}
                  retakeMode={this.props.retakeMode}
                  reviewMode={this.props.reviewMode}
                  setRetakeMode={this.props.setRetakeMode}
                  practiceExamResults={this.props.practiceExamResults}
                  setReviewMode={this.props.setReviewMode}
                  fromPSView={this.props.fromPSView}
                  isCurrentTabSKT={isCurrentTabSKT}
                />
              </div>
            )}
          </div>
        )}

        <div className="practice-exam-history-container">
          <div className="history-content pt-4 pl-3 pr-3">
            <h4>{weeklyExamTitle}</h4>
            <p className="weekly-practice-exam-description mb-0">
              A new exam is added each week, and the four most recent exams
              remain available.
            </p>
            <Mobile>
              <div className="mobile-practice-exam-selector mb-2">
                {this.renderDropDown('weekly')}
              </div>
            </Mobile>
          </div>

          {!isWeeklyEmpty && (
            <div className="history-content pt-4 pl-3 pr-3">
              <Cycle
                section="weekly"
                expirationWarningNextToAction={
                  this.props.expirationWarningNextToAction
                }
                selectOption={this.state.currentSelectOption}
                exams={exams}
                nextWeeklyGenerationAt={this.props.nextWeeklyGenerationAt}
                weeklyPracticeExamBuildInProgress={
                  this.props.weeklyPracticeExamBuildInProgress
                }
                user={this.props.user}
                openCancelPopUp={this.openCancelPopUp}
                startPracticeExam={this.props.startPracticeExam}
                practiceExamRunning={this.props.practiceExamRunning}
                practiceExamFlag={this.props.practiceExamFlag}
                checkPracticeExamLoading={this.props.checkPracticeExamLoading}
                retakeMode={this.props.retakeMode}
                reviewMode={this.props.reviewMode}
                setRetakeMode={this.props.setRetakeMode}
                practiceExamResults={this.props.practiceExamResults}
                setReviewMode={this.props.setReviewMode}
              />
            </div>
          )}

          {isWeeklyEmpty && (
            <div className="history-content py-4 px-3 no-results-container">
              There are no weekly practice exams available.
            </div>
          )}
        </div>

        <NotificationPopUp
          isOpen={this.state.showCancelPopUp}
          openCancelPopUp={this.openCancelPopUp}
          user={this.props.user}
        />
        {this.state.openCustomExamModal && (
          <CustomPracticeExam
            user={this.props.user}
            isOpen={this.state.openCustomExamModal}
            toggle={() => this.setState({ openCustomExamModal: false })}
            references={this.props.references}
            isLoadingReferences={this.props.isLoadingReferences}
            generateCustomPE={this.props.generateCustomPE}
            customPESettings={this.props.customPESettings}
            getCustomPESettings={this.props.getCustomPESettings}
            isLoadingPESettings={this.props.isLoadingPESettings}
          />
        )}
      </div>
    );
  }
}
PracticeExamHistoryView.propTypes = {
  exams: PropTypes.array,
  expirationWarningNextToAction: PropTypes.bool,
  getWeeklyPracticeExams: PropTypes.func.isRequired,
  nextWeeklyGenerationAt: PropTypes.number,
  weeklyPracticeExamBuildInProgress: PropTypes.bool,
  generateCustomPE: PropTypes.func.isRequired,
  isLoadingReferences: PropTypes.bool,
  loadReferences: PropTypes.func.isRequired,
  references: PropTypes.array,
};
export default PracticeExamHistoryView;
